import React, { useState } from 'react';
import { FaCar, FaTruck, FaBus } from 'react-icons/fa';
import suvImage from '../data/images/suv.png';
import './SimpleVehicleSelector.css';

const SimpleVehicleSelector = ({ selectedVehicle, onVehicleSelect }) => {
  const [imageErrors, setImageErrors] = useState({});

  const vehicles = [
    {
      id: 'sedan',
      name: 'Sedan',
      icon: FaCar,
      capacity: '4 passengers',
      price: '₹14/km',
      image: '/images/vehicles/sedan.png'
    },
    {
      id: 'suv',
      name: 'SUV',
      icon: FaTruck,
      capacity: '6 passengers',
      price: '₹19/km',
      image: suvImage
    },
    {
      id: 'innova',
      name: 'Innova',
      icon: FaBus,
      capacity: '7 passengers',
      price: '₹20/km',
      image: '/images/vehicles/innova.jpg'
    }
  ];

  const handleImageError = (vehicleId) => {
    setImageErrors(prev => ({
      ...prev,
      [vehicleId]: true
    }));
  };

  return (
    <div className="simple-vehicle-selector">
      <div className="vehicle-options">
        {vehicles.map((vehicle) => {
          const IconComponent = vehicle.icon;
          return (
            <div
              key={vehicle.id}
              className={`vehicle-option ${selectedVehicle === vehicle.id ? 'selected' : ''}`}
              onClick={() => onVehicleSelect(vehicle.id)}
            >
              <div className="vehicle-image-container">
                {!imageErrors[vehicle.id] ? (
                  <img
                    src={vehicle.image}
                    alt={vehicle.name}
                    className="vehicle-image"
                    onError={() => handleImageError(vehicle.id)}
                  />
                ) : (
                  <IconComponent className="vehicle-icon fallback-icon" />
                )}
              </div>
              <div className="vehicle-info">
                <span className="vehicle-name">{vehicle.name}</span>
                <span className="vehicle-price">{vehicle.price}</span>
                <span className="vehicle-capacity">{vehicle.capacity}</span>
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default SimpleVehicleSelector;
